// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Button } from 'semantic-ui-react';
import _ from 'lodash';
import DateFNS from 'date-fns';
// import DateFNSPT from 'date-fns/locale/pt';
// local
import t from 'app/lib/i18n';
import { formatNumber /*fromUTC*/ } from 'app/lib/helper';
// views
import EmptyList from 'app/ui/commons/emptyList/EmptyList';
// import { bold } from 'ansi-colors';

class ReportChangePatient extends Component {
    renderEmpty = () => <EmptyList emptyMessage="Não foram encontradas informações para o filtro configurado." />;

    renderTable(data, onClickSave) {
        const { dateFrom, dateTo, patient, rows, /*timeAverage,*/ totalWasted, startAverage } = data;
        const strPhone = [patient.phone1, patient.phone2, patient.phone3].filter(p => p).join(' / ');
        return (
            <React.Fragment>
                <div className="report">
                    <div className="date">
                        <span className="bold">Período:</span> {dateFrom} à {dateTo}
                    </div>
                    <div className="header">
                        <div className="title">SALVUS ATAS | Relatório de Momento da Troca de Cilindros por Paciente</div>
                        <div className="content">
                            <div>
                                Paciente: <span className="bold wrap">{patient.name}</span>
                            </div>
                            <div>
                                Fornecedor: <span className="bold wrap">{patient.supplier.name}</span>
                            </div>
                            <div>
                                Telefone: <span className="bold">{strPhone}</span>
                            </div>
                            <div>
                                Atendimento: <span className="bold">{patient.serviceNumber}</span>
                            </div>
                            <div>
                                Pescrição:{' '}
                                <span className="bold">
                                    {patient.prescription}
                                    L/min
                                </span>
                            </div>
                            <div>
                                CPF: <span className="bold">{patient.cpf}</span>
                            </div>
                            <div>
                                Tipo: <span className="bold">{t(`patient_period_type_${patient.periodType}`)}</span>
                            </div>
                            <div>
                                Plano de Saúde: <span className="bold wrap">{patient.healthInsurence}</span>
                            </div>
                            {patient.rg && (
                                <div>
                                    RG: <span className="bold">{patient.rg}</span>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="body">
                        <Table>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell textAlign="center" className="lastChangeReport" colSpan="3">
                                        ÚLTIMA LEITURA
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" className="newChangeReport" colSpan="3">
                                        NOVA LEITURA
                                    </Table.HeaderCell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.HeaderCell className="lastDate">DATA</Table.HeaderCell>
                                    <Table.HeaderCell>HORA</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" className="lastPressure">
                                        PRESSÃO
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>DATA</Table.HeaderCell>
                                    <Table.HeaderCell>HORA</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" className="newPressure">
                                        PRESSÃO
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {_.map(rows, row => {
                                    const { begin, end } = row;
                                    const key = _.uniqueId('row');
                                    // const date = fromUTC(new Date(row.historyDate));
                                    return (
                                        <Table.Row key={key}>
                                            <Table.Cell style={{ borderLeft: '1px solid #747474' }}>{DateFNS.format(end.date, 'DD/MM/YYYY')}</Table.Cell>
                                            <Table.Cell>{DateFNS.format(end.date, 'HH:mm:ss')}</Table.Cell>
                                            <Table.Cell textAlign="center" style={{ borderRight: '1px solid #747474' }}>
                                                {formatNumber(end.pressure)}
                                            </Table.Cell>
                                            <Table.Cell>{DateFNS.format(begin.date, 'DD/MM/YYYY')}</Table.Cell>
                                            <Table.Cell>{DateFNS.format(begin.date, 'HH:mm:ss')}</Table.Cell>
                                            <Table.Cell textAlign="center" style={{ borderRight: '1px solid #747474' }}>
                                                {formatNumber(begin.pressure)}
                                            </Table.Cell>
                                        </Table.Row>
                                    );
                                })}
                            </Table.Body>
                            <Table.Footer>
                                <Table.Row>
                                    <Table.Cell colSpan="2" />
                                    <Table.Cell textAlign="center">Desperdício</Table.Cell>
                                    <Table.Cell textAlign="center" colSpan="2" />
                                    <Table.Cell textAlign="center">Não Entregue</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell colSpan="2">TOTAL</Table.Cell>
                                    <Table.Cell textAlign="center">
                                        {formatNumber(totalWasted)}M<sup>3</sup>
                                    </Table.Cell>
                                    <Table.Cell textAlign="center" colSpan="2" />
                                    <Table.Cell textAlign="center">
                                        {formatNumber(startAverage)}M<sup>3</sup>
                                    </Table.Cell>
                                </Table.Row>
                            </Table.Footer>
                        </Table>
                    </div>
                </div>
                <Button className="btn-save" onClick={onClickSave}>
                    Salvar PDF
                </Button>
            </React.Fragment>
        );
    }

    render() {
        const { onClickSave, data } = this.props;
        return _.isEmpty(data.rows) ? this.renderEmpty() : this.renderTable(data, onClickSave);
    }
}

ReportChangePatient.propTypes = {
    data: PropTypes.object,
    onClickSave: PropTypes.func,
};

export default ReportChangePatient;
